import Dce from "dce-engine/lib/decorators/Dce";
import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceWebSocketConnection, DceWebSocketIncomingMessage, DceWebSocketSubscribeHandle} from "dce-websocket";

interface WSContentBlockProps {
    channel: string
}

@Dce("WSContentBlock")
export default class WSContentBlock extends DceComponent<WSContentBlockProps>{

    private subHandle: DceWebSocketSubscribeHandle;

    constructor(elem: DceHTMLElement, props: WSContentBlockProps | null) {
        super(elem, props);

        this.subHandle = DceWebSocketConnection.getInstance()
            .subscribe(this.props.channel, (msg) => {
                this.onMessage(msg);
            });
    }

    private onMessage(msg: DceWebSocketIncomingMessage): void {
        this.elem.innerHTML = msg.message;
    }

    onRemove() {
        DceWebSocketConnection.getInstance().unsubscribe(this.subHandle);
    }
}